import { useEffect, useRef } from "react"

import { ADMIN_OPERATOR_RUN_PROGRESS } from "@domain/ai_operator"
import { useSubscription } from "@apollo/client"
import { useQueryClient } from "@tanstack/react-query"

const REFETCH_DEBOUNCE_MS = 800

/** Refetches the Operator Logs list, health, open chat and open run whenever qpien-ai reports run progress (run start, each stage, DONE/FAILED). */
export default function useOperatorRunsRealtime(filters: {
  customerId?: string
  cPersonId?: string
}) {
  const queryClient = useQueryClient()
  const token = localStorage.getItem("authToken") ?? ""
  const timer = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => () => clearTimeout(timer.current), [])

  useSubscription(ADMIN_OPERATOR_RUN_PROGRESS, {
    variables: {
      data: {
        token,
        customerId: filters.customerId || undefined,
        cPersonId: filters.cPersonId || undefined
      }
    },
    skip: !token,
    onData: () => {
      clearTimeout(timer.current)
      timer.current = setTimeout(() => {
        void queryClient.invalidateQueries({ queryKey: ["ai-operator-runs"] })
        void queryClient.invalidateQueries({ queryKey: ["ai-operator-health"] })
        void queryClient.invalidateQueries({ queryKey: ["ai-operator-run"] })
        void queryClient.invalidateQueries({ queryKey: ["ai-operator-chat"] })
      }, REFETCH_DEBOUNCE_MS)
    }
  })
}
